<app-toast-host></app-toast-host>
<header [class]="[showHeader ? 'header-vis' : 'header-colp']">
  <!-- THE VERICURE V, not the United Felts lockup. This bar carries PRODUCT
       branding: it says what the application is, which is Vericure. United Felts
       is the theme — whose installation this is — and that belongs in the theme's
       colours, not in the product's name slot.

       A true one-path vector, so it stays crisp at any size and on any display.
       Not a link, for the same reason the lockup was not: the folder icon in the
       left nav already owns "go to project selection". -->
  <img src="assets/vericure-v-cobalt.svg" alt="Vericure" class="header-logo" />
  <span id="brand">{{ selectedProject }}</span>
  <!-- EVERY state gets a WORD. 'unknown' used to render a coloured dot and an
       empty span, so a grey dot said nothing at all — not to a glancing operator,
       not to a colourblind one, and not to a screen reader or a text scrape, which
       returned no connectivity information whatever. A colour on its own is a
       decoration, not an indicator.

       This is DEVICE connectivity — is the CMS reporting — which is a different
       fact from telemetry-transport health. If a transport indicator is added it
       must read as a separate thing, not a second opinion about this one. -->
  <span
    class="device-status"
    *ngIf="showDeviceStatus"
    [title]="deviceStatusLabel"
    [attr.aria-label]="'Device ' + deviceStatusLabel"
    role="status"
  >
    <span class="status-dot" [ngClass]="{
      'status-online': deviceStatus === 'online',
      'status-offline': deviceStatus === 'offline',
      'status-unknown': deviceStatus === 'unknown'
    }"></span>
    <span class="status-text">{{ deviceStatusLabel }}</span>
  </span>

  <!-- LIST-CHANNEL state — a SEPARATE FACT from the device pill above, as that
       comment requires. The device pill answers "is the CMS reporting". This
       answers "is this tab still being told when the project list changes".
       They can disagree in both directions and neither is a second opinion about
       the other, so this carries its own label rather than a shared dot.

       Rendered only for live/connecting/failed: 'idle' means we have not tried
       yet and 'disabled' means the feature is off here. Labelling either as a
       fault would cry wolf, which is the same reasoning that keeps 'unknown'
       out of the Offline label. -->
  <span
    class="list-channel"
    *ngIf="showListChannel"
    [title]="listChannelLabel"
    [attr.aria-label]="'Project list updates: ' + listChannelLabel"
    role="status"
  >
    <span class="channel-dot" [ngClass]="listChannelClass"></span>
    <span class="channel-text">{{ listChannelLabel }}</span>
  </span>
  <div class="spacer">
    <select
      name="projectList"
      id="projectList"
      #selectProject
      (change)="onProjectChange(selectProject.value)"
      [(ngModel)]="selectedProject"
      [hidden]="true"
    >
      <option
        *ngFor="let project of projectService.projectList"
        [value]="project.ProjectName"
      >
        {{ project.ProjectName }}
      </option>
    </select>
  </div>
  <span
    class="auth-note"
    *ngIf="!isAuthenticated && authStatus.kind !== 'signed-out'"
    [title]="authStatus.message"
  >
    <i class="fa-solid fa-triangle-exclamation"></i>
    <span class="auth-note-text">{{ authStatusLabel }}</span>
  </span>
  <button
    id="loginBtn"
    type="button"
    *ngIf="!isAuthenticated"
    (click)="login()"
  >{{ 'MainLayoutLogin' | t }}</button>
  <app-notification-bell *ngIf="isAuthenticated"></app-notification-bell>
  <div class="user-menu" #userMenuRef *ngIf="isAuthenticated">
    <span id="userDetails" (click)="toggleUserDropdown()">
      <span class="avatar-wrap">
        <i class="fa-solid fa-circle-user user-avatar"></i>
        <span
          class="auth-dot"
          [class.auth-dot-bad]="authDegraded"
          [title]="authStatus.message"
        ></span>
      </span>
      <span class="user-label">
        <span class="user-name">{{ getUserDisplayName() }}</span>
        <span class="user-company" *ngIf="activeCustomerName">{{ activeCustomerName }}</span>
      </span>
      <i class="fa-solid fa-chevron-down user-caret" [class.open]="userDropdownOpen"></i>
    </span>

    <div class="user-dropdown" *ngIf="userDropdownOpen">
      <!-- Account header -->
      <div class="dropdown-header">
        <div class="dh-name">{{ getUserDisplayName() }}</div>
        <!-- The TENANT you are signed in as — not the customer whose data you are
             viewing. Those are different things and the row below is the other. -->
        <div class="dh-tenant" *ngIf="authTenant">
          <i class="fa-solid fa-id-badge"></i>&nbsp;{{ authTenant }}
        </div>
        <div class="dh-company" *ngIf="activeCustomerName">
          <i class="fa-solid fa-building"></i>&nbsp;{{ activeCustomerName }}
        </div>
        <div
          class="dh-status"
          [class.bad]="authDegraded"
          [title]="authStatus.message"
        >
          <span class="status-pip"></span>{{ authStatusLabel }}
        </div>
        <div class="dh-status-detail" *ngIf="authDegraded">
          {{ authStatus.message }}
        </div>
      </div>

      <!-- Company switcher -->
      <ng-container *ngIf="showCustomerSwitcher()">
        <div class="dropdown-divider"></div>
        <div class="dropdown-section-label">{{ 'MainLayoutSwitchCompany' | t }}</div>

        <!-- Many companies: compact dropdown showing the selected company -->
        <div class="company-select-wrap" *ngIf="hasManyCustomers">
          <i class="fa-solid fa-building company-icon"></i>
          <select
            class="company-select"
            [ngModel]="activeCustomerKey"
            (ngModelChange)="onCompanySelect($event)"
          >
            <option *ngFor="let c of authService.availableCustomers" [value]="keyFor(c)">
              {{ labelFor(c) }}
            </option>
          </select>
          <i class="fa-solid fa-chevron-down company-select-caret"></i>
        </div>

        <!-- Few companies: quick-pick list -->
        <div class="company-list" *ngIf="!hasManyCustomers">
          <button
            class="dropdown-item company-item"
            *ngFor="let c of authService.availableCustomers"
            [class.active]="activeCustomerKey === keyFor(c)"
            (click)="switchCustomer(c); userDropdownOpen = false"
          >
            <i class="fa-solid fa-building company-icon"></i>
            <span class="company-name">{{ labelFor(c) }}</span>
            <i class="fa-solid fa-check company-check" *ngIf="activeCustomerKey === keyFor(c)"></i>
          </button>
        </div>
      </ng-container>

      <!-- Actions -->
      <div class="dropdown-divider"></div>
      <a class="dropdown-item" routerLink="/admin/preferences" (click)="userDropdownOpen = false">
        <i class="fa-solid fa-sliders item-icon"></i>{{ 'MainLayoutPreferences' | t }}</a>
      <a class="dropdown-item" routerLink="/admin" (click)="userDropdownOpen = false" *ngIf="isAdmin || isSuperAdmin">
        <i class="fa-solid fa-user-shield item-icon"></i>{{ 'MainLayoutAdmin' | t }}</a>
      <button class="dropdown-item" (click)="switchAccount()">
        <i class="fa-solid fa-right-left item-icon"></i>
        {{ authDegraded ? 'Sign in again' : 'Switch account' }}
      </button>
      <button class="dropdown-item" (click)="logout(); userDropdownOpen = false">
        <i class="fa-solid fa-right-from-bracket item-icon"></i>{{ 'MainLayoutSignOut' | t }}</button>
    </div>
  </div>
</header>
<div id="main">
  <div [class]="showFiberFaultColorClass()">
    <nav>
      <ul>
        <li>
          <img
            src="../../assets/Help/Project Upload.svg"
            class="help-left"
            *ngIf="this.projectService.isHelpOverlayVisible"
          />
          <!-- The folder means "choose a project" and now goes to the selection
               SCREEN. It used to open the picker as a dialog; since the dialog is
               upload-only, leaving it here would have made the one obvious
               affordance for opening a project do something else entirely. -->
          <div class="imgcontainer" routerLink="/projects" routerLinkActive="tab-selected" [title]="'MainLayoutSelectAProject' | t">
            <img src="../assets/open-folder.PNG" alt="" #openFolder />
          </div>
        </li>
        <li>
          <img
            src="../../assets/Help/Overview.svg"
            class="help-left"
            *ngIf="this.projectService.isHelpOverlayVisible"
          />
          <a
            href="#"
            class="link1"
            [class.tab-disabled]="!projectSelected"
            [attr.aria-disabled]="!projectSelected"
            [attr.title]="projectSelected ? null : noProjectReason"
            routerLinkActive="tab-selected"
            [routerLink]="projectSelected ? 'temperature' : null"
            queryParamsHandling="preserve"
            (click)="onTabClick($event)"></a>
        </li>
        <li>
          <img
            src="../../assets/Help/3D Graph.svg"
            class="help-left"
            *ngIf="this.projectService.isHelpOverlayVisible"
          />
          <a
            href="#"
            class="link2"
            [class.tab-disabled]="!projectSelected"
            [attr.aria-disabled]="!projectSelected"
            [attr.title]="projectSelected ? null : noProjectReason"
            routerLinkActive="tab-selected"
            [routerLink]="projectSelected ? 'graph' : null"
            queryParamsHandling="preserve"
            (click)="onTabClick($event)"></a>
        </li>
        <li>
          <img
            src="../../assets/Help/Curing.svg"
            class="help-left"
            *ngIf="this.projectService.isHelpOverlayVisible"
          />
          <a
            href="#"
            class="link3"
            [class.tab-disabled]="!projectSelected"
            [attr.aria-disabled]="!projectSelected"
            [attr.title]="projectSelected ? null : noProjectReason"
            routerLinkActive="tab-selected"
            [routerLink]="projectSelected ? 'curing' : null"
            queryParamsHandling="preserve"
            (click)="onTabClick($event)"></a>
        </li>
        <li>
          <img
            src="../../assets/Help/Multi View.svg"
            class="help-left"
            *ngIf="this.projectService.isHelpOverlayVisible"
          />
          <a
            href="#"
            class="link4"
            [class.tab-disabled]="!projectSelected"
            [attr.aria-disabled]="!projectSelected"
            [attr.title]="projectSelected ? null : noProjectReason"
            routerLinkActive="tab-selected"
            [routerLink]="projectSelected ? 'subviews' : null"
            queryParamsHandling="preserve"
            (click)="onTabClick($event)"></a>
        </li>
        <li>
          <img
            src="../../assets/Help/Note.svg"
            class="help-left"
            *ngIf="this.projectService.isHelpOverlayVisible"
          />
          <a
            href="#"
            class="link5"
            [class.tab-disabled]="!projectSelected"
            [attr.aria-disabled]="!projectSelected"
            [attr.title]="projectSelected ? null : noProjectReason"
            routerLinkActive="tab-selected"
            [routerLink]="projectSelected ? 'notes' : null"
            queryParamsHandling="preserve"
            (click)="onTabClick($event)"></a>
        </li>
        <li>
          <img
            src="../../assets/Help/CMS Health.svg"
            class="help-left"
            *ngIf="this.projectService.isHelpOverlayVisible"
          />
          <a
            href="#"
            class="link6"
            [class.tab-disabled]="!projectSelected"
            [attr.aria-disabled]="!projectSelected"
            [attr.title]="projectSelected ? null : noProjectReason"
            routerLinkActive="tab-selected"
            [routerLink]="projectSelected ? 'health' : null"
            queryParamsHandling="preserve"
            (click)="onTabClick($event)"></a>
        </li>
        <!-- <li>
          <a class="link6" [routerLink]="" (click)="showHealthPage()"></a>
        </li> -->
        <li>
          <img
            src="../../assets/Help/Quick settings.svg"
            class="help-left"
            *ngIf="this.projectService.isHelpOverlayVisible"
          />
          <a
            href="#"
            class="link7"
            [class.tab-disabled]="!projectSelected"
            [attr.aria-disabled]="!projectSelected"
            [attr.title]="projectSelected ? null : noProjectReason"
            routerLinkActive="tab-selected"
            [routerLink]="projectSelected ? 'info' : null"
            queryParamsHandling="preserve"
            (click)="onTabClick($event)"></a>
        </li>

        <!-- Cure Sheets — customer-level, so it sits with the folder and admin
             icons rather than in the project tab strip. Gated: a nav item that
             leads to a "not included" page is worse than no nav item. -->
        <li *ngIf="showCureSheets">
          <div class="imgcontainer" routerLink="/cure-sheets" routerLinkActive="tab-selected" [title]="'CureSheetsNav' | t">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 3h9l4 4v14a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z" stroke="white" stroke-width="1.7" stroke-linejoin="round"/>
              <path d="M14 3v5h5" stroke="white" stroke-width="1.7" stroke-linejoin="round"/>
              <path d="M8.5 12.5h7M8.5 16h4.5" stroke="white" stroke-width="1.7" stroke-linecap="round"/>
            </svg>
          </div>
        </li>

        <!-- Admin — visible to administrator and SuperAdmin only -->
        <li *ngIf="isAdmin || isSuperAdmin">
          <div class="imgcontainer admin-icon" routerLink="/admin" [title]="'MainLayoutAdmin' | t">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="8" r="3.5" stroke="white" stroke-width="1.8"/>
              <path d="M4 20c0-3.5 3.6-6 8-6s8 2.5 8 6" stroke="white" stroke-width="1.8" stroke-linecap="round"/>
              <circle cx="18.5" cy="6" r="2" fill="#0078d4" stroke="white" stroke-width="1"/>
            </svg>
          </div>
        </li>

        <!-- Export project — only visible when a project is loaded -->
        <li *ngIf="selectedProject && selectedProject.length > 0">
          <div
            class="imgcontainer export-toggle"
            [class.export-active]="showExportPanel"
            (click)="toggleExportPanel()"
            [title]="'ProjectMenuExportReport' | t"
          >
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
              <path d="M12 3v13M7 11l5 5 5-5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M4 19h16" stroke="white" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </div>
        </li>

        <!-- Export sub-icons: PDF and CSV — shown when export panel is open -->
        <ng-container *ngIf="showExportPanel && selectedProject && selectedProject.length > 0">
          <li class="export-subitem">
            <div
              class="imgcontainer export-subicon"
              [class.export-subicon-active]="exportPanelMode === 'pdf'"
              (click)="setExportMode('pdf')"
              [title]="'ExportPDF' | t"
            >
              <!-- PDF: document with folded corner + red PDF badge -->
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <path d="M5 2h9l4 4v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z" stroke="white" stroke-width="1.5"/>
                <path d="M14 2v4h4" stroke="white" stroke-width="1.5" stroke-linejoin="round"/>
                <rect x="4" y="13" width="10" height="5" rx="0.5" fill="#e05c00"/>
                <text x="5.5" y="17" font-size="4" fill="white" font-weight="bold" font-family="sans-serif">PDF</text>
              </svg>
            </div>
          </li>
          <li class="export-subitem">
            <div
              class="imgcontainer export-subicon"
              [class.export-subicon-active]="exportPanelMode === 'csv'"
              (click)="setExportMode('csv')"
              [title]="'ExportCSV' | t"
            >
              <!-- CSV: spreadsheet/grid icon (like Excel) -->
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <rect x="3" y="3" width="18" height="18" rx="1" stroke="white" stroke-width="1.5"/>
                <line x1="3" y1="9" x2="21" y2="9" stroke="white" stroke-width="1.2"/>
                <line x1="3" y1="15" x2="21" y2="15" stroke="white" stroke-width="1.2"/>
                <line x1="9" y1="3" x2="9" y2="21" stroke="white" stroke-width="1.2"/>
                <line x1="15" y1="3" x2="15" y2="21" stroke="white" stroke-width="1.2"/>
                <rect x="3" y="3" width="6" height="6" rx="0.5" fill="#107c10" opacity="0.85"/>
              </svg>
            </div>
          </li>
        </ng-container>
      </ul>
    </nav>
  </div>
  <div class="centerarea">
    <!-- export-hidden (visibility, not display:none): the active route keeps its
         layout + SciChart render loop while the export panel is open, so chart
         captures stay fresh instead of falling back to stale snapshots -->
    <div class="screen-content" [class.export-hidden]="showExportPanel">
      <router-outlet></router-outlet>
    </div>

    <!-- Export panel — replaces chart area when active -->
    <app-export-project
      *ngIf="showExportPanel"
      [projectName]="selectedProject"
      [tenantId]="getExportTenantId()"
      [unitCode]="projectService.isMetricUnit ? 0 : 1"
      [exportMode]="exportPanelMode"
    ></app-export-project>

    <!-- Offscreen host for export prerendering: never-visited chart components
         are instantiated here (real size, offscreen) so their SciChart surfaces
         exist for PDF capture. See ExportPrerenderService. -->
    <div class="offscreen-chart-host">
      <ng-container #offscreenChartHost></ng-container>
    </div>

    <!-- THE PLAYBACK TRANSPORT BELONGS TO THE CHART TABS. It sits after the
         router-outlet, so ungated it renders under every routed screen — Joel found
         it at the bottom of the project selection grid, a horizontal slider with no
         chart to scrub, and it was doing the same under the admin console. -->
    <div class="chart-controls" *ngIf="onProjectTab" [class.hidden]="showExportPanel">
      <div class="play-controls">
        <button (click)="setTickToBeginning()">
          <img src="../assets/prev.svg" />
        </button>
        <button (click)="toggleTimer()">
          <img src="../assets/play.svg" />
        </button>
        <button (click)="setTickToEnd()">
          <img src="../assets/prev.svg" class="reverse" />
        </button>
        <!-- <ul>
          <li (click)="setTimer()">
            <a [routerLink]="" class="linkPlayPause"></a>
          </li>
          <li (click)="stopTimer()">
            <a [routerLink]="" class="linkPlayPause"></a>
          </li>
        </ul> -->
      </div>
      <div class="slidecontainer">
        <input
          type="range"
          min="0"
          [max]="tickMax"
          value="50"
          class="slider"
          id="myRange"
          [value]="tick"
          #myRange
          (input)="updateChartDataForTick(myRange.value)"
        />
        <span class="durationText">{{
          projectService.formatDurationInSecToHHMMSS_Custom(this.currDuration)
        }}</span>
        <span class="timeText">{{
          this.currTime | vcDate: 'seconds'
        }}</span>
      </div>
    </div>
  </div>
  <div class="rightcontrols"></div>
  <div
    class="loading"
    *ngIf="
      tempDataLoading ||
      zoneDataLoading ||
      lossDataLoading ||
      notesDataLoading ||
      projUploading ||
      telemetryInFlight
    "
  >
    <!-- role=status + aria-live announce the state change to a screen reader
         without stealing focus; aria-busy marks the region as not-yet-settled.
         The pinwheel itself is aria-hidden — it carries no information the
         adjacent text does not already say, and announcing it would be noise. -->
    <div class="loading-panel" role="status" aria-live="polite" aria-busy="true">
      <div class="loading-pinwheel" aria-hidden="true"></div>
      <div *ngIf="projUploading" class="loading-msg">
        Uploading Project: {{ projectLoadPerc }}%
      </div>
      <!-- ONE branch, not two. There used to be a 0% case carrying the
           translated string and a >0% case carrying an untranslated literal
           "Loading" plus an HTML entity, so the percent appeared only in the
           branch that had lost its translation. Now the wording always comes
           from the dictionary and the percent is appended once it is worth
           showing. The ellipsis lives in the dictionary as a real character:
           an entity inside an interpolated string renders literally. -->
      <div *ngIf="!projUploading" class="loading-msg">
        {{ 'MainLayoutLoadingHellip' | t }}<span *ngIf="projectLoadPerc > 0"> {{ projectLoadPerc }}%</span>
      </div>
    </div>
  </div>

  <!-- AN EMPTY PROJECT SAYS SO.
       Before this, a project whose backfill returned no rows showed empty charts
       inside a normal-looking app and waited forever behind a gate that never
       opened — indistinguishable, to the user, from a load still in progress.
       Shown only once the load has settled, so it can never race the spinner. -->
  <div
    class="history-empty"
    *ngIf="
      (historyEmpty || historyFailed) &&
      !tempDataLoading &&
      !zoneDataLoading &&
      !lossDataLoading &&
      !projUploading
    "
    role="status"
    aria-live="polite"
  >
    <div class="history-empty-panel">
      <div class="history-empty-title">
        {{ historyFailed ? 'Could not load this project' : 'No data for this project' }}
      </div>
      <div class="history-empty-detail">
        {{
          historyFailed
            ? 'The telemetry request failed. Reopening the project will try again.'
            : 'This project recorded no telemetry over its lifetime.'
        }}
      </div>
    </div>
  </div>
</div>
<footer></footer>

<!-- Project Selection Modal -->
<div class="modal-overlay" 
     *ngIf="showProjectModal" 
     (click)="closeProjectModal('Overlay clicked')"
     (keydown)="onModalKeyDown($event)"
     tabindex="0"
     [class.maximized]="isModalMaximized">
  <div class="modal-content" 
       (click)="$event.stopPropagation()"
       [class.maximized]="isModalMaximized"
       [class.minimized]="isModalMinimized"
       [class.resizing]="isModalResizing">
    <div class="modal-header">
      <h2>{{ 'MainLayoutUploadProject' | t }}</h2>
      <div class="modal-controls">
        <button class="control-btn minimize-btn" 
                (click)="minimizeModal()"
                [title]="'MainLayoutMinimize' | t">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
            <path d="M2 6H10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
        <button class="control-btn maximize-btn" 
                (click)="toggleMaximizeModal()"
                [title]="isModalMaximized ? 'Restore (F11)' : 'Maximize (F11)'">
          <svg *ngIf="!isModalMaximized" width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
            <rect x="2" y="2" width="8" height="8" stroke="currentColor" stroke-width="1" fill="none"/>
          </svg>
          <svg *ngIf="isModalMaximized" width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
            <rect x="3" y="1" width="7" height="7" stroke="currentColor" stroke-width="1" fill="none"/>
            <rect x="1" y="3" width="7" height="7" stroke="currentColor" stroke-width="1" fill="none"/>
          </svg>
        </button>
        <button class="control-btn close-btn" 
                (click)="closeProjectModal('Close button clicked')"
                [title]="'MainLayoutCloseEsc' | t">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
            <path d="M1 1L11 11M11 1L1 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
    </div>
    
    <!-- Resize handles -->
    <div class="resize-handles" *ngIf="!isModalMaximized && !isModalMinimized">
      <div class="resize-handle resize-handle-n" (mousedown)="onModalMouseDown($event)"></div>
      <div class="resize-handle resize-handle-s" (mousedown)="onModalMouseDown($event)"></div>
      <div class="resize-handle resize-handle-e" (mousedown)="onModalMouseDown($event)"></div>
      <div class="resize-handle resize-handle-w" (mousedown)="onModalMouseDown($event)"></div>
      <div class="resize-handle resize-handle-ne" (mousedown)="onModalMouseDown($event)"></div>
      <div class="resize-handle resize-handle-nw" (mousedown)="onModalMouseDown($event)"></div>
      <div class="resize-handle resize-handle-se" (mousedown)="onModalMouseDown($event)"></div>
      <div class="resize-handle resize-handle-sw" (mousedown)="onModalMouseDown($event)"></div>
    </div>
    
      
      <!-- Upload Tab -->
      <div *ngIf="activeTab === 'upload'" class="tab-content">
        <div class="upload-area">

          <!-- Idle: pick a file -->
          <div *ngIf="uploadPhase === 'idle'" class="upload-picker">
            <!-- ONE SENTENCE, ONE KEY. This was three pieces — a head, a bolded ".zip" and
                 a tail — concatenated around markup, which cannot be translated: German
                 puts those parts in a different order, and a translator handed the tail
                 alone has no sentence to reorder. The format moves into a {format}
                 placeholder they CAN move. The bold is the price; correct grammar in five
                 languages is worth more than emphasis on a file extension. -->
            <p class="upload-hint">{{ 'MainLayoutChooseProjectZipHint' | t: { format: '.zip' } }}</p>
            <input
              #uploadInput
              type="file"
              accept=".zip,application/zip"
              class="upload-file-input"
              (change)="onUploadFileSelected($event)" />
            <div *ngIf="uploadFile" class="upload-file-chosen">
              {{ uploadFile.name }} <span class="upload-size">({{ uploadFileSize }})</span>
            </div>
            <button
              class="upload-btn"
              [disabled]="!uploadFile"
              (click)="startUpload()">{{ 'MainLayoutUploadProject' | t }}</button>
          </div>

          <!-- Working -->
          <div *ngIf="uploadPhase === 'working'" class="upload-progress">
            <p class="upload-status">{{ uploadStatusText }}</p>
            <div class="upload-bar"><div class="upload-bar-fill" [style.width.%]="projectLoadPerc"></div></div>
            <p class="upload-detail">{{ projectLoadPerc }}% &middot; {{ uploadDetailText }}</p>
            <button class="upload-cancel-btn" (click)="cancelUpload()">{{ 'HelpProjectWizardCancel' | t }}</button>
          </div>

          <!-- Failed: never silent -->
          <div *ngIf="uploadPhase === 'error'" class="upload-error" role="alert">
            <p class="upload-error-title">{{ 'MainLayoutUploadFailed' | t }}</p>
            <p class="upload-error-msg">{{ uploadErrorMessage }}</p>
            <p *ngIf="uploadErrorDetail" class="upload-error-detail">{{ uploadErrorDetail }}</p>
            <button class="upload-btn" (click)="resetUpload()">{{ 'MainLayoutTryAgain' | t }}</button>
          </div>

          <!-- Done -->
          <div *ngIf="uploadPhase === 'done'" class="upload-done" role="status">
            <p class="upload-done-title">{{ 'MainLayoutUploaded' | t }}</p>
            <p class="upload-done-msg">
              {{ 'MainLayoutProjectIsInExistingList' | t: { project: uploadedProjectName } }}</p>
            <p *ngIf="uploadedSummary" class="upload-detail">{{ uploadedSummary }}</p>
            <button class="upload-btn" (click)="goToUploadedProject()">{{ 'MainLayoutOpenIt' | t }}</button>
            <button class="upload-cancel-btn" (click)="resetUpload()">{{ 'MainLayoutUploadAnother' | t }}</button>
          </div>

        </div>
      </div>
    </div>
  </div>

<!-- <app-heatmap></app-heatmap> -->
<!--  -->
